import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressMetrics = ({ metrics }) => {
  const metricCards = [
    {
      label: 'Total Tasks',
      value: metrics?.totalTasks,
      icon: 'FileText',
      color: 'blue',
      bgColor: 'bg-blue-500/10',
      iconColor: 'var(--color-primary)'
    },
    {
      label: 'Completed',
      value: metrics?.completed,
      icon: 'CheckCircle',
      color: 'green',
      bgColor: 'bg-green-500/10',
      iconColor: '#10b981'
    },
    {
      label: 'In Progress',
      value: metrics?.inProgress,
      icon: 'Clock',
      color: 'orange',
      bgColor: 'bg-orange-500/10',
      iconColor: '#f59e0b'
    },
    {
      label: 'Overdue',
      value: metrics?.overdue,
      icon: 'AlertCircle',
      color: 'red',
      bgColor: 'bg-red-500/10',
      iconColor: '#ef4444'
    },
    {
      label: 'Completion Rate',
      value: `${metrics?.completionRate}%`,
      icon: 'TrendingUp',
      color: 'purple',
      bgColor: 'bg-purple-500/10',
      iconColor: '#8b5cf6'
    },
    {
      label: 'Avg Resolution Time',
      value: `${metrics?.avgResolutionTime} days`,
      icon: 'Timer',
      color: 'cyan',
      bgColor: 'bg-cyan-500/10',
      iconColor: '#06b6d4'
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
      {metricCards?.map((card, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-4 hover:shadow-lg transition-shadow"
        >
          <div className="flex items-center justify-between mb-3">
            <div className={`w-10 h-10 rounded-lg ${card?.bgColor} flex items-center justify-center`}>
              <Icon name={card?.icon} size={20} color={card?.iconColor} />
            </div>
          </div>
          <p className="text-2xl font-bold text-foreground mb-1">{card?.value}</p>
          <p className="text-xs text-muted-foreground">{card?.label}</p>
        </div>
      ))}
    </div>
  );
};

export default ProgressMetrics;